import { Box, styled, SxProps, Typography } from '@mui/material'

import { switcherSubheadingStyle } from 'common/styles'

interface ImageCardProps {
  image: string
  imageAltText: string
  heading?: string
  subheading?: string
}

const styles: Record<string, SxProps> = {
  box: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: '12px 16px',
    borderRadius: '4px',
  },
  textBox: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '16px',
    flexGrow: 1,
    minWidth: 0,
  },
}

const Image = styled('img')(() => ({
  maxWidth: '96px',
  maxHeight: '72px',
  objectFit: 'contain',
}))

export default function ImageCard({
  heading,
  subheading,
  image,
  imageAltText,
}: ImageCardProps): JSX.Element {
  const { box, textBox } = styles

  const isHeadingExist = heading !== undefined && heading !== ''
  const isSubheadingExist = subheading !== undefined && subheading !== ''

  return (
    <Box className="image-card" sx={box} component="span">
      <Image src={image} alt={imageAltText} />
      {(isHeadingExist || isSubheadingExist) && (
        <Box component="span" sx={textBox} className="image-card-txt-wrap">
          {isHeadingExist && <Typography component="span">{heading}</Typography>}
          {isSubheadingExist && (
            <Typography component="span" sx={switcherSubheadingStyle}>
              {subheading}
            </Typography>
          )}
        </Box>
      )}
    </Box>
  )
}
